export default "__VITE_ASSET__Csc06j3w__"